import React from 'react'
import s from './SelectProfessional.module.scss'
import { ReactComponent as Checked } from 'images/new-icons/checked.svg'
import { ReactComponent as Unchecked } from 'images/new-icons/unchecked.svg'
import useGetSpecialistRating from 'sdk/hooks/salon/useGetSpecialistRating'
import SpecialistRating from 'components/shared/SpecialistRating'

const Card = ({ id, selectedId, avatar, fullName, handleChoose }) => {
    const { data } = useGetSpecialistRating(id);

    const formatName = (name) => {
        const [firstName, lastName] = name.split(' ');
        return lastName ? `${firstName} ${lastName[0]}` : firstName;
    };
    return (
        <div className={s.card} onClick={() => handleChoose(id)}>
            <div className={s.card_checkbox}>
                {selectedId === id ? <Checked /> : <Unchecked />}
            </div>
            <img src={avatar} className={s.card_img} alt={fullName} />
            <div className={s.card_inf}>
                <div className={s.card_inf_name}>{formatName(fullName)}</div>
                <div className={s.card_inf_rating}>
                    <SpecialistRating rating={data?.average || 0} count={data?.count} showCount />
                </div>
            </div>
        </div>
    )
}

export default Card